// CON-9505. PayPal is not a Stripe payment method, so its row cannot come out of the Payment Element —
// it has to be built by hand. These tokens are the single source both sides read, which is the only
// reason a hand-built row can sit in the same list as Stripe's accordion items without looking bolted on.
//
// Change a value here and both move together. Change one side only and they drift apart, which is
// exactly what this module exists to prevent.
export const METHOD_BORDER = '#E6E6E6'
export const METHOD_ACCENT = '#0570DE'
export const METHOD_RADIUS = '8px'
export const METHOD_TEXT = '#30313D'
export const METHOD_BG = '#FFFFFF'
export const METHOD_BG_HOVER = '#F7F8F9'
export const METHOD_PADDING = '14px 16px'
export const METHOD_SPACING = '12px'
export const METHOD_SHADOW = '0 1px 1px rgba(0, 0, 0, 0.03)'
export const METHOD_TRANSITION =
    'background-color 120ms ease, border-color 120ms ease, box-shadow 120ms ease'
export const METHOD_LABEL_SIZE = '15px'
export const METHOD_LABEL_WEIGHT = '500'
export const METHOD_FONT = 'Arial, sans-serif'

export const checkoutAppearance = {
    theme: 'stripe',
    labels: 'floating',
    variables: {
        borderRadius: METHOD_RADIUS,
        colorPrimary: METHOD_ACCENT,
        colorBackground: METHOD_BG,
        colorText: METHOD_TEXT,
        colorDanger: '#df1b41',
        fontFamily: METHOD_FONT,
        accordionItemSpacing: METHOD_SPACING,
        accordionItemLabelColorText: METHOD_TEXT,
        // The selected row names itself in the accent colour, which is how the buyer sees which
        // method they are paying with. The hand-built PayPal row matches it when open.
        accordionItemLabelSelectedColorText: METHOD_ACCENT,
        accordionItemLabelFontSize: METHOD_LABEL_SIZE,
        accordionItemLabelFontWeight: METHOD_LABEL_WEIGHT,
        accordionItemLabelSelectedFontWeight: METHOD_LABEL_WEIGHT,
    },
    rules: {
        '.AccordionItem': {
            backgroundColor: METHOD_BG,
            border: `1px solid ${METHOD_BORDER}`,
            borderRadius: METHOD_RADIUS,
            boxShadow: METHOD_SHADOW,
            padding: METHOD_PADDING,
        },
        '.AccordionItem:hover': {
            backgroundColor: METHOD_BG_HOVER,
        },
        // Card fields live inside an accordion item now, so they are styled to sit within a row rather
        // than to be the form themselves.
        '.Input': {
            borderColor: METHOD_BORDER,
            padding: '0.75em 1em',
            boxShadow: 'none',
            outline: 'none',
        },
        '.Input:focus': {
            borderColor: METHOD_ACCENT,
            outline: 'none',
            boxShadow: 'none',
        },
        '.Input--invalid': {
            marginBottom: '10px',
        },
        '.Error': {
            marginTop: '8px',
        },
        '.Label--floating': {
            color: '#999',
            fontSize: '0.8em',
            marginTop: '-5px',
        },
        '.Label--focused': {
            color: '#999',
        },
    },
}

export default checkoutAppearance
